import type { PropsWithChildren } from 'react';

import { FetchErrorSection } from '..';
import { Loader } from '../Loader/Loader';

interface IProp {
  isError: boolean;
  isLoading: boolean;
}

export const FetchDataWrapper = ({ isError, isLoading, children }: PropsWithChildren<IProp>) => {
  if (isLoading) {
    return <Loader isSpinning />;
  }

  if (isError) {
    return <FetchErrorSection />;
  }

  return children;
};
